module.exports = __webpack_public_path__ + "static/media/doc-download-icon.a377e4c3.svg";